import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { NativeAudio } from '@ionic-native/native-audio';
 
@Injectable()
export class SmartAudio {
 
    //this.nativeAudio.setVolumeForComplexAsset('uniqueId2', 0.6).then(onSuccess,onError);

    audioType: string = 'html5';
    sounds: any = [];
    currentBgMusic:any;

    volume:number;
 
    constructor(public nativeAudio: NativeAudio, platform: Platform) {
        if(platform.is('cordova')){
            this.audioType = 'native';
        }
        this.volume=0; //TODO use 100 after develop, values 0-100
    }
    
    getCurrentVolume(){
      return this.volume/100;
    }

    /* Manage sound effects */ 
    preloadSimple(key, asset) { //cannot be stopped or looped
        if(this.audioType === 'html5'){
            let audio = {
                key: key,
                asset: asset,
                type: 'html5'
            };
            this.sounds.push(audio);
        } else {
            this.nativeAudio.preloadSimple(key, asset);
            let audio = {
                key: key,
                asset: asset,
                type: 'native'
            };
            this.sounds.push(audio);
        }       
    }
 
    play(key){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
 
      if(audio.type === 'html5'){ 
        let audioAsset = new Audio(audio.asset);
        audioAsset.play();
      } else { 
        this.nativeAudio.play(audio.asset).then((res) => {
          console.log(res);
          }, (err) => {
          console.log(err);
        });
      }
    }
    
    /* Manage Background Music */
    preloadComplex(key, asset, volume, voices, delay) {
        if(this.audioType === 'html5'){
            let audio = {
                key: key,
                asset: asset,
                type: 'html5'
            };
            this.sounds.push(audio);
        } else {
            this.nativeAudio.preloadComplex(key, asset, volume, voices, delay);
            let audio = {
                key: key,
                asset: asset,
                type: 'native'
            };
            this.sounds.push(audio);
        }   
    }

    setBgVolume(key){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });

      if(audio.type === 'html5'){ 
        this.currentBgMusic.volume=this.getCurrentVolume();
      } else { 
        this.nativeAudio.setVolumeForComplexAsset(audio.asset, this.getCurrentVolume());
      }
    }

    startBgMusic(key){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
 
      if(audio.type === 'html5'){ 
        this.currentBgMusic = new Audio(audio.asset);
        this.currentBgMusic.loop=true;
        this.currentBgMusic.volume=this.getCurrentVolume();
        this.currentBgMusic.play();
      } else { 
        this.nativeAudio.loop(audio.asset).then((res) => {
          console.log(res);
          }, (err) => {
          console.log(err);
        });
      }
    }

    stopBgMusic(key){
      let audio = this.sounds.find((sound) => {
        return sound.key === key;
      });
 
      if(audio.type === 'html5'){ 
        this.currentBgMusic.currentTime=0;
        this.currentBgMusic.pause();
        /*
        TODO FADE OUT
        this.currentBgMusic.animate(
		      { volume: 0 }, // Target volume
          100, // How long should the fadeout take
		      function() {
			      this.currentBgMusic.pause(); // Pause the audio
			      this.currentBgMusic.currentTime = 0; // Be kind, rewind.
			      this.currentBgMusic.volume = 1; // Reset volume
          }
        );
        */ 

      } else { 
        this.nativeAudio.stop(audio.asset).then((res) => {
          console.log(res);
          }, (err) => {
          console.log(err);
        });
      }
    }

  changeVolumeApp(){
    this.setBgVolume('game_1_BgMusic');
    this.setBgVolume('game_2_BgMusic');
    this.setBgVolume('game_3_BgMusic');
    this.setBgVolume('game_4_BgMusic');
    this.setBgVolume('game_5_BgMusic');
    this.setBgVolume('game_6_BgMusic');

    this.setBgVolume('game_youLost');
    this.setBgVolume('game_youWin');
  }
}



// WEBPACK FOOTER //
// ./src/providers/smart-audio.ts